// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { buildFromLocalStorage } from 'conversations-internal-schema/last-viewed-inbox/operators/buildFromLocalStorage';
import { getLastViewedViewId
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
} from 'conversations-internal-schema/last-viewed-inbox/operators/getters';
export const getLastViewedViewFromLocalStorage = () => {
  const lastViewed = buildFromLocalStorage();
  const viewId = getLastViewedViewId(lastViewed);
  return viewId;
};